<template>
  <div class="page-experts-detail">
    <Loading v-if="loading" :count="6"></Loading>
    <el-descriptions v-else :column="1">
      <el-descriptions-item label="姓名">
        {{ detail.name }}
      </el-descriptions-item>
       <el-descriptions-item label="所属竞赛">
        {{ detail.jsName }}
      </el-descriptions-item>
      <el-descriptions-item label="手机号">
        {{ detail.phone }}
      </el-descriptions-item>
      <el-descriptions-item label="企业">
        {{ detail.company }}
      </el-descriptions-item>
      <el-descriptions-item label="身份证号">
        {{ detail.idNum }}
      </el-descriptions-item>
      <el-descriptions-item label="开户行">
        {{ detail.bank }}
      </el-descriptions-item>
      <el-descriptions-item label="银行卡号">
        {{ detail.cardNum }}
      </el-descriptions-item>
      <el-descriptions-item label="职称">
        {{ detail.title }}
      </el-descriptions-item>
      <el-descriptions-item label="备注">
        {{ detail.remark }}
      </el-descriptions-item>
      <!-- <el-descriptions-item label="密码">
        {{ detail.password }}
      </el-descriptions-item> -->
    </el-descriptions>
  </div>
</template>

<script>
import Loading from '@/components/loading'

export default {
  components: {
    Loading
  },
  data() {
    return {
      loading: true,
      id: this.$route.params.id,
      detail: null
    }
  },
  mounted() {
    this.fetchDetail()
  },
  methods: {
    async fetchDetail() {
      this.loading = true
      const [err, res] = await this.$serve.jsExpert.info({
        queryId: this.id
      })
      this.loading = false
      if (err) return
      this.detail = res
    }
  }
}
</script>

<style lang="scss" scoped>
.page-experts-detail {
  ::v-deep {
    .el-descriptions-item__container {
      min-height: 40px;
      line-height: 40px;
    }
    .el-descriptions-item__label {
      width: 120px;
      text-align: right;
    }
  }
}
</style>
